import React, {Component} from "react";
import {Menu} from "antd";

const SubMenu = Menu.SubMenu;

class SideNav extends Component {

    constructor(props) {
        super(props);
        const { selectKey } = props;
        this.state = {
            current: selectKey,
        };
    }

    handleClick = e => {
        this.setState({
            current: e.key,
        });
    }

    render() {
        const { curRole, isInvAreaLeader } = sessionStorage;
        const isCTA = curRole == 'CTA';
        const isPM = curRole == 'PM';
        const isBO = curRole == 'BO';
        const isCRC = curRole == 'CRC';
        const isCRCC = curRole == 'CRCC';
        const isCRCM = curRole == 'CRCM';
        const isVP = curRole == 'VP';
        const isFIN = curRole == 'FIN';
        const isPML = curRole == 'PML';
        const isHRRC = curRole == 'HRRC';
        
        return (
            <aside className="sidebar">    
                <Menu
                    onClick={this.handleClick}
                    defaultOpenKeys={['sub1']}
                    selectedKeys={[this.state.current]}
                    mode="inline"
                    >
                    <SubMenu key="sub1" title={<span><i className="icon iconfont">&#xe629;</i><span>工时记录</span></span>}>
                    { 
                        (isPM || isCRC || isCRCC || isCRCM || isPML) &&
                        <Menu.Item key="write">
                            <a href="#/manHour/write">填写工时</a>
                        </Menu.Item>
                    }
                    { 
                        (isPM || isCRC || isCRCC || isCRCM || isPML) &&
                        <Menu.Item key="myHour">
                            <a href="#/manHour/myHour">我的工时</a>
                        </Menu.Item>
                    }
                    {
                        (isPM || isCRC || isCRCC || isCRCM || isPML) &&
                        <Menu.Item key="monthlyFte">
                            <a href="#/manHour/monthlyFte">月度FTE</a>
                        </Menu.Item>
                    }
                    { 
                        (isPM || isCRC || isCRCC || isCRCM || isPML) &&
                        <Menu.Item key="myWeekly">
                            <a href="#/manHour/myWeekly">我的周报</a>
                        </Menu.Item>
                    }
                    { 
                        (isCRC || isCRCC || isPM || isPML) &&
                        <Menu.Item key="myEfficiency">
                            <a href="#/manHour/myEfficiency">我的效率</a>
                        </Menu.Item>
                    }
                    { 
                        (isCRCC || isCRCM || isBO || isPM || isCTA || isVP || isFIN || isPML || isHRRC) &&
                        <Menu.Item key="query">
                            <a href="#/manHour/query">工时查询</a>
                        </Menu.Item>
                    }
                    { 
                        (isBO || isCTA || isVP || isFIN || isHRRC) &&
                        <Menu.Item key="report">
                            <a href="#/manHour/report">工时报告</a>
                        </Menu.Item>
                    }
                    { 
                        (isBO || isPM || isCRCC || isCRCM || isCRC || isCTA || isPML) &&
                        <Menu.Item key="confirm">
                            <a href="#/manHour/confirm">待确认工时</a>
                        </Menu.Item>
                    }
                    { 
                        (isBO || (isInvAreaLeader == 'true')) &&
                        <Menu.Item key="unconfirmProManhour">
                            <a href="#/manHour/unconfirmProManhour">未确认工时项目清单</a>
                        </Menu.Item>
                    }
                    </SubMenu>
                </Menu>      
            </aside>
        );
    }
}

export default SideNav;



// WEBPACK FOOTER //
// ./src/components/manHour/SideNav.js